<mat-icon data-qa='thumb-rating-icon' class='icon-2x me-2'>{{matIcon}}</mat-icon>
<div data-qa='thumb-rating-label' *ngIf='status'>{{'components.thumbRating.' + status.toLowerCase() | translate}}</div>
